import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    createStyles,
    Button,
    Collapse,
    Textarea,
    ScrollArea,
    FileInput,
} from '@mantine/core';
import { nanoid } from '@reduxjs/toolkit';
import {
    DateRangePicker,
    TimeInput
} from '@mantine/dates';
import { IconUpload } from '@tabler/icons';

import { CarCreationCardCCompMediaUpload } from '../components/CarCreationCardCCompMediaUpload';
import { CarCreationCardCVideoEmbedding } from '../components/CarCreationCardCVideoEmbedding';





const useStyles = createStyles((theme) => ({
    buttonContainer: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        borderTop: `1px solid ${
            theme.colorScheme === 'dark' ? theme.colors.dark[5] : theme.colors.gray[2]
        }`,
    },
    buttonArea: {
        width: '49%',
        justifyContent: 'center',
    },
    buttonItem: {
        position: 'relative',
        left: '25%'
    }
    
}));


export function CarCreationCardC() {
    const [sectionCOpen, setSectionCOpened] = useState(false);
    const { classes } = useStyles();
    const dispatch = useDispatch();
    
    const [briefDescript, setBriefDescript] = useState('');
    const onBriefDescriptChanged = (e) => setBriefDescript(e.target.value);
    
    
    //descript:personal photos and video of the car
    //needed:add docs for items
    const personalMediaUpload = [
        {
            itemName: "photos_2_3"
        },
        {
            itemName: "videos_2_3"
        },
    ];
    
    const persMedUpldSection = personalMediaUpload.map((item, index) =>
        <CarCreationCardCCompMediaUpload
            key={nanoid()}
            itemName={item.itemName}
        />
    )
    //use video js and its youtube plugin... good practice 
    const videoEmbedding = [
        {
            placeHolder: 'Embed Youtube Videos',
            itemLabel: 'Embed Videos',
            itemName: 'embed_videos_2_0',
        }
    ]
    const embedVidsSection = videoEmbedding.map((item, index) =>
        <CarCreationCardCVideoEmbedding
            key={nanoid()}
            placeHolder={item.placeHolder}
            itemLabel={item.itemLabel}
            itemName={item.itemName}
        />
    )
    
    
    //needed:make a call to the db
    //needed:city and states in ref db
    //needed:custom image and card as the select model

    //needed:event list w/parallel handlers and error handling(ref text input contolled)
    //of_note:make this into a modal
    return (
        <>
            {persMedUpldSection}
            {embedVidsSection}
        </>
    );
    
}

